import { render, staticRenderFns } from "./selectScroll.vue?vue&type=template&id=0ad2df86&scoped=true"
import script from "./selectScroll.vue?vue&type=script&lang=js"
export * from "./selectScroll.vue?vue&type=script&lang=js"
import style0 from "./selectScroll.vue?vue&type=style&index=0&id=0ad2df86&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad2df86",
  null
  
)

export default component.exports